module.exports = __webpack_public_path__ + "Sheppard56.webp?39fe0df6eed8dd53ca7102e22356b476";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/Sheppard56.webp
// module id = 160
// module chunks = 0